import { useState } from "react";
import DiagnosticPage from "./DiagnosticPage";
import TestCreationPage from "./TestCreationPage";
import {
  initialFilterStateDiagnostic,
  initialFilterStateTestCreation,
} from "./helper";
import ParameterCreationPage from "./ParameterCreationPage";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const TestCreation = () => {
  const [isRowData, setIsRowData] = useState(null);
  const [isRowDataTest, setIsRowDataTest] = useState(null);
  const [searchFilter, setSearchFilter] = useState(
    initialFilterStateDiagnostic
  );
  const [searchFilterTest, setSearchFilterTest] = useState(
    initialFilterStateTestCreation
  );
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    if (globalReducer?.clearStatePage) {
      setIsRowData(null);
      setIsRowDataTest(null);
      setSearchFilter(initialFilterStateDiagnostic);
      setSearchFilterTest(initialFilterStateTestCreation);
    }
  }, [globalReducer?.clearStatePage]);

  return isRowData === null ? (
    <DiagnosticPage
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
      setIsRowData={setIsRowData}
      isRowData={isRowData}
    />
  ) : isRowDataTest === null ? (
    <TestCreationPage
      isRowData={isRowData}
      setIsRowData={setIsRowData}
      searchFilter={searchFilter}
      isRowDataTest={isRowDataTest}
      setIsRowDataTest={setIsRowDataTest}
      searchFilterTest={searchFilterTest}
      setSearchFilterTest={setSearchFilterTest}
    />
  ) : (
    <ParameterCreationPage
      isRowDataTest={isRowDataTest}
      setIsRowDataTest={setIsRowDataTest}
      searchFilterTest={searchFilterTest}
    />
  );
};

export default TestCreation;
